import { getLoggedUserFullName } from 'utils';
import { format } from 'date-fns';

export const getOrderPayload = (order, vsTypes, isRequired) => {
    // const getCertificateDetails = () => {
    //     return {
    //         certificateOwnerOneId: order?.certificateOwnerOneDetails?.gpid,
    //         certificateOwnerOneName: order?.certificateOwnerOneDetails?.name,
    //         certificateOwnerTwoId: order?.certificateOwnerTwoDetails?.gpid,
    //         certificateOwnerTwoName: order?.certificateOwnerTwoDetails?.name,
    //     };
    // };

    const payload = {
        applicationService: order?.applicationService,
        applicationOwner: order?.applicationOwnerDetails?.gpid || null,
        applicationOwnerDetails: order?.applicationOwnerDetails,
        ...(order?.sector && { sector: order?.sector }),
        // division: order?.division,
        region: order?.regionDetails?.data?.name,
        environment: order?.environment,
        // programName: order?.program,
        // department: order?.department,
        aksCluster: order?.aksCluster,
        aksNamespace: order?.aksNamespace,
        ...((order?.aksVirtualServiceRequestType === 'UPDATE' ||
            (order?.aksVirtualServiceRequestType === 'CREATE' && order?.aksVirtualService?.some((item) => item?.customDomainSelected === 'Yes'))) && {
            keyVaultName: order?.keyVaultName,
            spcName: order?.spcName,
            keyVaultRegion: order?.keyVaultRegion,
        }),
        costCenter: order?.costCenter?.trim(),
        enabledManualBudgetCode: order?.enabledManualBudgetCode,
        appSupportMailId: order?.appSupportMailId,
        ...(isRequired && { activeDirectoryCertificateGroup: order?.adCertGroup }),
        tags: {
            Environment: order?.environment,
            Sector: order?.sector,
            Servicename: order?.applicationService,
            Provisioneddate: format(new Date(), 'yyyy-MM-dd'),
            Requestedby: getLoggedUserFullName(),
            'pep-business-category': order?.businessCategory,
            'pep-dataclassification': order?.applicationServiceDetails?.data?.dataClassification,
        },
        ...(order?.aksVirtualServiceRequestType?.toLowerCase() === 'update' && {
            aksVirtualService: order?.aksVirtualServiceUpdateCustomDomain?.map((updateItem) => ({
                requestType: order?.aksVirtualServiceRequestType?.toLowerCase(),
                customDomainSelected: true,
                certificateCreationRequired: updateItem?.certificateExists === false,
                customDomain: [
                    {
                        name: updateItem?.name,
                        aksIngressUrl: updateItem?.aksIngressUrl,
                    },
                ],
            })),
        }),
        ...(order?.aksVirtualServiceRequestType?.toLowerCase() !== 'update' && {
            aksVirtualService: order?.aksVirtualService?.map((item) => {
                const getAksCorsPayload = (aksCors) => {
                    return {
                        ...(aksCors?.allowedMethods?.length && { allowedMethods: aksCors?.allowedMethods }),
                        allowedOrigins: aksCors?.allowedOrigins?.map((origin) => origin?.allowedOrigin),
                        ...(aksCors?.allowedHeaders?.[0]?.allowedHeader && {
                            allowedHeaders: aksCors?.allowedHeaders?.map((header) => header?.allowedHeader?.label),
                        }),
                        ...(aksCors?.exposeHeaders?.[0]?.exposeHeader && {
                            exposeHeaders: aksCors?.exposeHeaders?.map((header) => header?.exposeHeader?.label),
                        }),
                    };
                };

                return {
                    requestType: order?.aksVirtualServiceRequestType?.toLowerCase(),
                    virtualServiceType: vsTypes?.find((z) => z.label === item?.virtualServiceType)?.value,
                    virtualServiceTypeName: item?.virtualServiceType,
                    virtualServiceName: item?.virtualServiceName,
                    hostNamesPrefix: item?.hostNamesPrefix?.map((host) => host?.hostNamePrefix),
                    customDomainSelected: item?.customDomainSelected === 'Yes',
                    ...(item?.customDomainSelected === 'Yes' && {
                        customDomain: [{ name: item?.customDomain?.[0]?.name }],
                        certificateCreationRequired: item?.certificateExists === false,
                    }),
                    corsPolicy: item?.corsPolicy === 'Yes',
                    aksService: item?.aksService,
                    ...(item?.corsPolicy === 'Yes' && { aksCors: getAksCorsPayload(item?.aksCors) }),
                };
            }),
        }),
    };

    return payload;
};

export const formOrderObjFromOrderDetails = (data = null) => {
    if (data?.catalogServices?.[0]?.catalogConfig) {
        const response = data?.catalogServices?.[0]?.catalogConfig;
        const isVSUpdateView = response?.aksVirtualService.some((item) => item?.requestType?.toLowerCase() === 'update');

        const virtualServiceUpdateData = response?.aksVirtualService?.map((item) => {
            return {
                name: item?.customDomain?.[0]?.name,
                aksIngressUrl: item?.customDomain?.[0]?.aksIngressUrl,
                certificateExists: item?.certificateCreationRequired === false,
            };
        });

        const virtualServiceData = response?.aksVirtualService?.map((item) => {
            if (isVSUpdateView) {
                return item?.customDomain[0];
            }

            const aksCors = item?.aksCors;
            return {
                virtualServiceType: item?.virtualServiceTypeName,
                virtualServiceName: item?.virtualServiceName,
                hostNamesPrefix: item?.hostNamesPrefix?.map((host) => ({ hostNamePrefix: host, isHostNameTouched: false })),
                customDomainSelected: item?.customDomainSelected ? 'Yes' : 'No',
                customDomain: [
                    {
                        name: item?.customDomain?.[0]?.name || null,
                    },
                ],
                certificateExists: item?.certificateCreationRequired === false,
                corsPolicy: item?.corsPolicy ? 'Yes' : 'No',
                aksService: item?.aksService,
                aksCors: {
                    allowedHeaders: aksCors?.allowedHeaders
                        ? aksCors?.allowedHeaders?.map((header) => ({
                              allowedHeader: {
                                  label: header,
                                  value: header,
                              },
                              isAllowedHeaderTouched: false,
                          }))
                        : [{ allowedHeader: null, isInvalid: false, isAllowedHeaderTouched: false }],
                    allowedOrigins: aksCors?.allowedOrigins?.map((origin) => ({
                        allowedOrigin: origin,
                        isAllowedOriginTouched: false,
                        isInvalid: false,
                    })),
                    exposeHeaders: aksCors?.exposeHeaders
                        ? aksCors?.exposeHeaders?.map((header) => ({
                              exposeHeader: {
                                  label: header,
                                  value: header,
                              },
                              isExposeHeaderTouched: false,
                          }))
                        : [{ exposeHeader: null, isInvalid: false, isAllowedHeaderTouched: false }],
                    allowedMethods: aksCors?.allowedMethods,
                },
            };
        });

        return {
            applicationService: response?.applicationService,
            ...(response?.applicationService && {
                applicationServiceDetails: {
                    label: response?.applicationService,
                    value: response?.applicationService,
                    data: { dataClassification: response?.tags?.['pep-dataclassification'] },
                },
            }),
            businessCategory: response?.tags?.['pep-business-category'] || null,
            sector: response?.sector,
            division: response?.division,
            environment: response?.environment,
            region: response?.region,
            program: response?.programName === 'Global Shared' ? 'Not Applicable' : response?.programName,
            // department: response?.department,
            aksCluster: response?.aksCluster,
            aksNamespace: response?.aksNamespace,
            keyVaultName: response?.keyVaultName,
            spcName: response?.spcName,
            keyVaultRegion: response?.keyVaultRegion,
            costCenter: response?.costCenter,
            enabledManualBudgetCode: response?.enabledManualBudgetCode || true,
            adCertGroup: response?.activeDirectoryCertificateGroup,
            appSupportMailId: response?.appSupportMailId,
            // certificateOwnerOne: response?.certificateDetails?.certificateOwnerOneName || null,
            // certificateOwnerOneDetails: response?.certificateDetails
            //     ? {
            //           name: response?.certificateDetails?.certificateOwnerOneName,
            //           gpid: response?.certificateDetails?.certificateOwnerOneId,
            //       }
            //     : null,
            // certificateOwnerTwo: response?.certificateDetails?.certificateOwnerTwoName || null,
            // certificateOwnerTwoDetails: response?.certificateDetails
            //     ? {
            //           name: response?.certificateDetails?.certificateOwnerTwoName,
            //           gpid: response?.certificateDetails?.certificateOwnerTwoId,
            //       }
            //     : null,
            applicationOwner: data?.manager?.name?.toLowerCase() !== 'system' ? data?.manager?.name : null,
            applicationOwnerDetails: data?.manager?.name?.toLowerCase() !== 'system' ? { name: data?.manager?.name, gpid: data?.manager?.id } : null,
            aksVirtualServiceRequestType: isVSUpdateView ? 'UPDATE' : 'CREATE',
            ...(!isVSUpdateView && { aksVirtualService: virtualServiceData }),
            ...(isVSUpdateView && { aksVirtualServiceUpdateCustomDomain: virtualServiceUpdateData, aksVirtualService: virtualServiceData }),
        };
    }
    return null;
};

export const isDisplayField = (options, field) => {
    switch (field) {
        case 'appRegion':
        case 'division':
            return options?.length > 1;
        case 'program':
            return !(options?.length === 1 && options?.[0]?.value?.toLowerCase() === 'not applicable');
        default:
            return true;
    }
};

export const platformManaged = 'EIAP';

export const getRandomString = (length) => {
    const alphabets = 'abcdefghijklmnopqrstuvwxyz';
    const randomString = Array(length)
        .join()
        .split(',')
        .map(() => {
            return alphabets.charAt(Math.floor(Math.random() * alphabets.length));
        })
        .join('');
    return randomString;
};

export const isUniqueOwner = (value = null, selectedvalues = []) => {
    return selectedvalues.indexOf(value) === -1;
};
